import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazonprimeComponent } from './simple-icons-amazonprime.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazonprimeComponent ],
    exports:      [ SimpleIconsAmazonprimeComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazonprimeModule {}
